import {
  create_franchisee,
  update_franchisee,
  delete_franchisee,
  recover_franchisee,
  query_franchisee_list,
} from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-franchisee-config';

import { onMounted, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'q',
      label: '模糊搜索',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写搜索内容',
    },
    {
      type: 'input',
      name: 'code',
      label: '加盟商编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '加盟商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商名称',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    q: null,
    name: null,
    code: null,
    person_id: null,
    person_name: null,
    phone: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '加盟商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '加盟商编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商编号',
    },
    {
      type: 'input',
      name: 'address',
      label: '加盟商地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商地址',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '加盟商联系人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择加盟商联系人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入名称' }],
    person_id: [{ required: true, message: '请填选择加盟商联系人' }],
    code: [{ required: true, message: '请填加盟商编号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    person_id: null,
    phone: null,
    code: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '加盟商名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '加盟商编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商编号',
    },
    {
      type: 'input',
      name: 'address',
      label: '加盟商地址',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写加盟商地址',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '加盟商联系人',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择加盟商联系人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    person_id: [{ required: true, message: '请选择绑定登录账号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    address: null,
    person_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '加盟商管理',
  addModalTitle: '新建加盟商',
  updateTitle: '修改加盟商',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    franchisee_id: 'id',
  },
  delete: {
    franchisee_id: 'id',
  },
  recover: {
    franchisee_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    franchisee_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '加盟商编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '加盟商名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '加盟商地址',
    dataIndex: 'address',
    checked: true,
  },
  {
    title: '加盟商联系人',
    dataIndex: 'person_name',
    checked: true,
  },
  {
    title: '加盟商联系电话',
    dataIndex: 'person_phone',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  const route = useRoute();
  search_config.model.q = route.query.q;
  onMounted(() => {
    watch(
      () => route.query,
      () => {
        if (route.path == '/mjstore_company/jms-franchisee' && route.query.q) {
          // search_config.model.q = route.query.q;
          event_obj.emit('refresh_search', { q: route.query.q });
        }
      },
    );
  });
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_franchisee_list,
    addData: create_franchisee,
    updateData: update_franchisee,
    removeData: delete_franchisee,
    recoverData: recover_franchisee,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
